import { z } from 'my-zod'

/** see https://www.andiamo.co.uk/resources/iso-language-codes/ */

export const StrictLanguageEnum = z.enum(['es-mx', 'fr-ca', 'fr', 'pl', 'en-us']).setEnumLabels({
  'es-mx': 'Spanish (Mexico)',
  'fr-ca': 'French (Canadian)',
  fr: 'French',
  pl: 'Polish',
  'en-us': 'English (US)'
})

export const LanguageEnum = StrictLanguageEnum.nullable().nullable()

export const Languages = LanguageEnum.unwrap().unwrap().Values
export const LanguagesLabels = LanguageEnum.unwrap().unwrap().enumLabels

export const LanguageOptions = ['es-mx', 'fr-ca', 'fr', 'pl', 'en-us'] as const

export type Language = z.infer<typeof LanguageEnum>
export type StrictLanguage = z.infer<typeof StrictLanguageEnum>

export function GetStrictLanguage(ln: any = null): StrictLanguage {
  if (LanguageOptions.includes(ln)) return ln
  return ln === 'es' ? 'es-mx' : 'en-us'
}
